import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Col, Form, Input } from 'antd';
export const FormInputText = ({ name, label, isRequired = false, placeholder = '', disabled = false, readOnly = false, maxLength = 190, showCounter = false, rules = [], hidden = false, isRow = false, className = '', col = 24, responsive, value, onChange, ...props }) => {
    const validationRules = [
        ...(isRequired ? [{ required: true, message: `Trường ${label ?? 'này'} không được để trống!` }] : []),
        ...rules
    ];
    const handleInputChange = (e) => {
        if (onChange)
            onChange(e);
    };
    const inputElement = (_jsx(Input, { ...props, placeholder: disabled || readOnly ? ' ' : placeholder || `Nhập ${label?.toLowerCase() || ''}...`, bordered: !readOnly, disabled: disabled, readOnly: readOnly, maxLength: maxLength, showCount: showCounter, style: {
            color: '#000',
            ...(isRow ? { flex: 1 } : {}),
            ...(props.styles || {}) // merge với props.styles nếu có
        }, value: value, onChange: handleInputChange }));
    const colProps = responsive ?? { xs: col, sm: col, md: col, lg: col, xl: col, xxl: col };
    return (_jsx(Col, { ...colProps, style: { display: hidden ? 'none' : 'block' }, children: name ? (_jsx(Form.Item, { label: isRow ? undefined : label, name: name, rules: validationRules, hidden: hidden, className: className, children: isRow ? (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8 }, children: [_jsxs("label", { style: {
                            minWidth: '20%',
                            fontWeight: 500,
                            marginBottom: 0,
                            whiteSpace: 'nowrap'
                        }, children: [label, isRequired && _jsx("span", { style: { color: 'red' }, children: " *" })] }), inputElement] })) : (inputElement) })) : (_jsxs("div", { style: {
                display: isRow ? 'flex' : 'block',
                alignItems: 'center',
                gap: 8
            }, children: [label && (_jsxs("label", { style: {
                        display: 'block',
                        fontWeight: 600,
                        fontSize: 13,
                        marginBottom: isRow ? 0 : 10,
                        whiteSpace: 'nowrap'
                    }, children: [label, isRequired && _jsx("span", { style: { color: 'red' }, children: " *" })] })), inputElement] })) }));
};
